import dayjs from "dayjs";
import {
  convertDateFormat,
  convertDateTimeFormat,
  filterDateFn,
  filterDateTimeFn,
  sortingDateFn,
  sortingDateTimeFn,
  sortingDateTimeYMDFn,
  sortingDateYMDFn,
} from "../common/common";

export const skuMovementSummaryEnquiryColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions",
    accessorKey: "skuDescriptions",
  },
  {
    header: "Opening Quantity",
    accessorKey: "openingQuantityStr",
  },
  {
    header: "In Quantity",
    accessorKey: "inQuantityStr",
  },
  {
    header: "Out Quantity",
    accessorKey: "outQuantityStr",
  },
  {
    header: "Adjust Quantity",
    accessorKey: "adjustQuantityStr",
  },
  {
    header: "Closing Quantity",
    accessorKey: "closingQuantityStr",
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
  },
  {
    header: "Ref 1",
    accessorKey: "ref1",
  },
  {
    header: "Ref 2",
    accessorKey: "ref2",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
];

export const skuMovementEnquiryColumns = [
  {
    header: "Date",
    accessorKey: "date",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Activity",
    accessorKey: "activity",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions",
    accessorKey: "skuDescriptions",
  },
  {
    header: "Pallet Number",
    accessorKey: "palletNbr",
  },
  {
    header: "Opening Quantity",
    accessorKey: "openingQuantityStr",
  },
  {
    header: "In Quantity",
    accessorKey: "inQuantityStr",
  },
  {
    header: "Out Quantity",
    accessorKey: "outQuantityStr",
  },
  {
    header: "Adjust Quantity",
    accessorKey: "adjustQuantityStr",
  },
  {
    header: "Closing Quantity",
    accessorKey: "closingQuantityStr",
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Ref 1",
    accessorKey: "ref1",
  },
  {
    header: "Ref 2",
    accessorKey: "ref2",
  },
  // {
  //   header: "Channel ID",
  //   accessorKey: "channelID",
  // },
  // {
  //   header: "Computation",
  //   accessorKey: "computation",
  // },
  {
    header: "Category",
    accessorKey: "category",
  },
];

export const stockInventoryEnquiryColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions",
    accessorKey: "skuDescriptions",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "Computation",
    accessorKey: "computation",
  },
  {
    header: "Barcode",
    accessorKey: "barcode",
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  },
  {
    header: "Location Type",
    accessorKey: "locationType",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "Batch Nbr",
    accessorKey: "batchNbr",
  },
  {
    header: "Pallet Nbr",
    accessorKey: "palletNbr",
  },
  {
    header: "Inventory Qty",
    accessorKey: "inventoryQty",
  },
  {
    header: "Hold Qty",
    accessorKey: "holdQty",
  },
  {
    header: "Committed Qty",
    accessorKey: "committedQty",
  },
  {
    header: "Allocated Qty",
    accessorKey: "allocatedQty",
  },
  {
    header: "Balance Qty",
    accessorKey: "balanceQty",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "UPM Cubic",
    accessorKey: "upmCubic",
  },
  {
    header: "Total SKU Cubic",
    accessorKey: "totalSKUCubic",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "SKU Group",
    accessorKey: "skuGroup",
  },
  {
    header: "SKU Sub Group",
    accessorKey: "skuSubGroup",
  },
  {
    header: "Shelf Life",
    accessorKey: "shelfLife",
  },
  {
    header: "Manufacturing Date",
    accessorKey: "manufacturingDate",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Recv Code",
    accessorKey: "recvCode",
  },
  {
    header: "Date Received",
    accessorKey: "dateReceived",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Recv Type",
    accessorKey: "recvType",
  },
  {
    header: "PO Number",
    accessorKey: "poNumber",
  },
  {
    header: "VDONo",
    accessorKey: "vDONo",
  },
  {
    header: "VInvNo",
    accessorKey: "vInvNo",
  },
];

export const orderDetailsStatusEnquiryColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  // {
  //   header: "Order Number",
  //   accessorKey: "orderNumber",
  // },
  {
    header: "Cust Order Number",
    accessorKey: "custOrdNbr",
  },
  {
    header: "Order Date",
    accessorKey: "orderDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "ESO Create Date",
    accessorKey: "esoCreateDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "SO Converted Date",
    accessorKey: "soConvertedDate",
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "DO Number",
    accessorKey: "doNumber",
  },

  {
    header: "DO Create Date",
    accessorKey: "doCreateDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Manifest Number",
    accessorKey: "manifestNumber",
  },
  {
    header: "Load Date",
    accessorKey: "loadDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "POD Date",
    accessorKey: "podDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Shipment Cancel Date",
    accessorKey: "shipmentCancelDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Cust Name",
    accessorKey: "custName",
  },
  {
    header: "Marketplace",
    accessorKey: "marketplace",
  },
  {
    header: "Reference No",
    accessorKey: "referenceNo",
  },
  {
    header: "PO No",
    accessorKey: "poNo",
  },
  {
    header: "Order Type",
    accessorKey: "orderType",
  },
  {
    header: "Consignee Code",
    accessorKey: "consigneeCode",
  },
  // {
  //   header: "Ship Company",
  //   accessorKey: "shipCompany",
  // },
  // {
  //   header: "Ship Address 1",
  //   accessorKey: "shipAddress1",
  // },
  // {
  //   header: "Ship Address 2",
  //   accessorKey: "shipAddress2",
  // },
  {
    header: "Ship Postcode",
    accessorKey: "shipPostcode",
  },

  // {
  //   header: "Ship City",
  //   accessorKey: "shipCity",
  // },
  // {
  //   header: "Ship State",
  //   accessorKey: "shipState",
  // },
  // {
  //   header: "Ship Contact",
  //   accessorKey: "shipContact",
  // },
  // {
  //   header: "Ship Phone",
  //   accessorKey: "ShipPhone",
  // },
  {
    header: "Shipping Zone",
    accessorKey: "shippingZone",
  },
  // {
  //   header: "Zone Description",
  //   accessorKey: "zoneDescription",
  // },
  {
    header: "Tracking Number",
    accessorKey: "trackingNumber",
  },
  {
    header: "AWB URL",
    accessorKey: "awbUrl",
  },
  {
    header: "Carrier",
    accessorKey: "carrier",
  },
  // {
  //   header: "Truck No",
  //   accessorKey: "truckNo",
  // },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Order Line No",
    accessorKey: "orderLineNo",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Description",
    accessorKey: "skuDescription",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "Order Quantity",
    accessorKey: "orderQuantity",
  },
  {
    header: "Shipped Quantity",
    accessorKey: "shippedQuantity",
  },
  {
    header: "Cancel Quantity",
    accessorKey: "cancelQuantity",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    filterFn: filterDateFn,
    cell: (row) => convertDateFormat(row.getValue()),
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Computation",
    accessorKey: "computation",
  },
  {
    header: "Remark",
    accessorKey: "remark",
  },
  {
    header: "Picked By",
    accessorKey: "pickedBy",
  },
  {
    header: "Date Pack Start",
    accessorKey: "datePackStart",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Date Pack Complete",
    accessorKey: "datePackComplete",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Packed By",
    accessorKey: "packedBy",
  },
  {
    header: "Pickslip Create Date",
    accessorKey: "pickslipCreateDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Pickslip Number",
    accessorKey: "pickslipNo",
  },
  {
    header: "Wave Number",
    accessorKey: "waveNumber",
  },
  {
    header: "Engraving",
    accessorKey: "engraving",
  },
  {
    header: "Pickslip Serial Number",
    accessorKey: "pickslipSerialNo",
  },
  {
    header: "SKU Group",
    accessorKey: "skuGroup",
  },
  {
    header: "SKU Sub Group",
    accessorKey: "skuSubGroup",
  },
  {
    header: "Priority Tag",
    accessorKey: "priorityTag",
  }
];

export const orderSummaryColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  // {
  //   header: "Order Number",
  //   accessorKey: "orderNumber",
  // },
  {
    header: "Cust Order Number",
    accessorKey: "custOrdNbr",
  },
  {
    header: "Order Date",
    accessorKey: "orderDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "ESO Create Date",
    accessorKey: "esoCreateDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "SO Converted Date",
    accessorKey: "soConvertedDate",
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "DO Number",
    accessorKey: "doNumber",
  },

  {
    header: "DO Create Date",
    accessorKey: "doCreateDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Manifest Number",
    accessorKey: "manifestNumber",
  },
  {
    header: "Load Date",
    accessorKey: "loadDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "POD Date",
    accessorKey: "podDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Shipment Cancel Date",
    accessorKey: "shipmentCancelDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Cust Name",
    accessorKey: "custName",
  },
  {
    header: "Marketplace",
    accessorKey: "marketplace",
  },
  {
    header: "Reference No",
    accessorKey: "referenceNo",
  },
  {
    header: "PO No",
    accessorKey: "poNo",
  },
  {
    header: "Order Type",
    accessorKey: "orderType",
  },
  {
    header: "Consignee Code",
    accessorKey: "consigneeCode",
  },
  // {
  //   header: "Ship Company",
  //   accessorKey: "shipCompany",
  // },
  // {
  //   header: "Ship Address 1",
  //   accessorKey: "shipAddress1",
  // },
  // {
  //   header: "Ship Address 2",
  //   accessorKey: "shipAddress2",
  // },
  {
    header: "Ship Postcode",
    accessorKey: "shipPostcode",
  },

  // {
  //   header: "Ship City",
  //   accessorKey: "shipCity",
  // },
  // {
  //   header: "Ship State",
  //   accessorKey: "shipState",
  // },
  // {
  //   header: "Ship Contact",
  //   accessorKey: "shipContact",
  // },
  // {
  //   header: "Ship Phone",
  //   accessorKey: "ShipPhone",
  // },
  {
    header: "Shipping Zone",
    accessorKey: "shippingZone",
  },
  // {
  //   header: "Zone Description",
  //   accessorKey: "zoneDescription",
  // },
  {
    header: "Tracking Number",
    accessorKey: "trackingNumber",
  },
  {
    header: "AWB URL",
    accessorKey: "awbUrl",
  },
  {
    header: "Carrier",
    accessorKey: "carrier",
  },
  // {
  //   header: "Truck No",
  //   accessorKey: "truckNo",
  // },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Order Line No",
    accessorKey: "orderLineNo",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Description",
    accessorKey: "skuDescription",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "Order Quantity",
    accessorKey: "orderQuantity",
  },
  {
    header: "Shipped Quantity",
    accessorKey: "shippedQuantity",
  },
  {
    header: "Cancel Quantity",
    accessorKey: "cancelQuantity",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  // {
  //   header: "Expiry Date",
  //   accessorKey: "expiryDate",
  //   filterFn: filterDateFn,
  //   cell: (row) => convertDateFormat(row.getValue()),
  //   sortingFn: sortingDateYMDFn,
  // },
  // {
  //   header: "MLN",
  //   accessorKey: "mln",
  // },
  {
    header: "Computation",
    accessorKey: "computation",
  },
  {
    header: "Remark",
    accessorKey: "remark",
  },
  {
    header: "Picked By",
    accessorKey: "pickedBy",
  },
  {
    header: "Packed By",
    accessorKey: "packedBy",
  },
  {
    header: "Pickslip Create Date",
    accessorKey: "pickslipCreateDate",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Pickslip Number",
    accessorKey: "pickslipNo",
  },
  {
    header: "Wave Number",
    accessorKey: "waveNumber",
  },
  {
    header: "Engraving",
    accessorKey: "engraving",
  },
  {
    header: "Engraving Info",
    accessorKey: "engravingInfo",
    cell: (row) => {
      if (row.getValue() === "") return row.getValue();
      return row.getValue().split("|").map((x,index) => (
        <p key={index}>{x}</p>
      ))
    }
  },
  {
    header: "Pickslip Serial Number",
    accessorKey: "pickslipSerialNo",
  },
  {
    header: "Box Type",
    accessorKey: "boxType",
  },
  {
    header: "SKU Group",
    accessorKey: "skuGroup",
  },
  {
    header: "SKU Sub Group",
    accessorKey: "skuSubGroup",
  },
];

export const AgingReportEnquiryColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "Category",
    accessorKey: "skuCategory",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions",
    accessorKey: "skuDescriptions",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "PO Number",
    accessorKey: "poNumber",
  },
  {
    header: "ASN Number",
    accessorKey: "asnNumber",
  },
  {
    header: "GRN No",
    accessorKey: "grnNo",
  },
  {
    header: "Date Received",
    accessorKey: "dateReceived",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "Pallet Number",
    accessorKey: "palletNbr",
  },
  {
    header: "<0 day",
    accessorKey: "dateRange1",
  },
  {
    header: "0 - 30 days",
    accessorKey: "dateRange2",
  },
  {
    header: "31 - 60 days",
    accessorKey: "dateRange3",
  },
  {
    header: "61 - 90 days",
    accessorKey: "dateRange4",
  },
  {
    header: "91 - 120 days",
    accessorKey: "dateRange5",
  },
  {
    header: "121 - 150 days",
    accessorKey: "dateRange6",
  },
  {
    header: "151 - 180 days",
    accessorKey: "dateRange7",
  },
  {
    header: ">180 days",
    accessorKey: "dateRange8",
  },
  {
    header: "Allocated Qty",
    accessorKey: "allocatedQty",
  },
  {
    header: "Balance Qty",
    accessorKey: "balanceQty",
  },
];

export const POReceivingColumns = [
  {
    header: "PO Number",
    accessorKey: "poNumber",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "PO Date",
    accessorKey: "poDate",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "PO Completed Date",
    accessorKey: "poCompletedDate",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "PO Type",
    accessorKey: "poType",
  },
  {
    header: "Seller Ref",
    accessorKey: "sellerRef",
  },
  {
    header: "Buyer Ref",
    accessorKey: "buyerRef",
  },
  {
    header: "Remark",
    accessorKey: "remark",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "Seller Company",
    accessorKey: "sellerCompany",
  },
  {
    header: "PO Status",
    accessorKey: "poStatus",
  },
  {
    header: "Line No",
    accessorKey: "lineNo",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "Description",
    accessorKey: "descriptions1",
  },
  {
    header: "PO Qty",
    accessorKey: "poQty",
  },
  {
    header: "Qty Received",
    accessorKey: "qtyReceived",
  },
  {
    header: "Diff Qty",
    accessorKey: "diffQty",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "POD Status",
    accessorKey: "podStatus",
  },
  {
    header: "SKU CBM",
    accessorKey: "skuCBM",
  },
  {
    header: "Total CBM",
    accessorKey: "totalCBM",
  },
];

export const ShelfLifeReportEnquiryColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Days to Expired",
    accessorKey: "daysToExpired",
  },
  {
    header: "SKU Shelf Life",
    accessorKey: "skuShelfLife",
  },
  {
    header: "SKU Descriptions",
    accessorKey: "skuDescriptions",
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
];

export const AdjustmentColumns = [
  {
    header: "Adjustment No",
    accessorKey: "adjustmentNo",
  },
  {
    header: "Adjustment Date",
    accessorKey: "adjustmentDate",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "Type",
    accessorKey: "type",
  },
  {
    header: "RC Descriptions1",
    accessorKey: "rcDescriptions1",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions1",
    accessorKey: "skuDescriptions1",
  },
  {
    header: "Adjust Quantity",
    accessorKey: "adjustQuantity",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUom",
  },
  {
    header: "Remark",
    accessorKey: "remark",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
];

export const TransferColumns = [
  {
    header: "Transfer No",
    accessorKey: "transferNo",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Line No",
    accessorKey: "lineNo",
  },
  {
    header: "From Customer",
    accessorKey: "fromCustomer",
  },
  {
    header: "From Vendor",
    accessorKey: "fromVendor",
  },
  {
    header: "From SKU",
    accessorKey: "fromSKU",
  },
  {
    header: "From Pack Type",
    accessorKey: "fromPackType",
  },
  {
    header: "From Pallet Nbr",
    accessorKey: "fromPalletNbr",
  },
  {
    header: "Carton Id",
    accessorKey: "cartonId",
  },
  {
    header: "From OLN",
    accessorKey: "fromOLN",
  },
  {
    header: "From Warehouse",
    accessorKey: "fromWarehouse",
  },
  {
    header: "From Zone",
    accessorKey: "fromZone",
  },
  {
    header: "From Location",
    accessorKey: "fromLocation",
  },
  {
    header: "To Customer",
    accessorKey: "toCustomer",
  },
  {
    header: "To Pallet Nbr",
    accessorKey: "toPalletNbr",
  },
  {
    header: "To Carton Id",
    accessorKey: "toCartonId",
  },
  {
    header: "To OLN",
    accessorKey: "toOLN",
  },
  {
    header: "To Warehouse",
    accessorKey: "toWarehouse",
  },
  {
    header: "To Zone",
    accessorKey: "toZone",
  },
  {
    header: "To Location",
    accessorKey: "toLocation",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Manufacturing Date",
    accessorKey: "manufacturingDate",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Transfer Qty",
    accessorKey: "transferQty",
  },
  {
    header: "UOM",
    accessorKey: "uom",
  },
  {
    header: "Remark",
    accessorKey: "remark",
  },
  // {
  //   header: "Status",
  //   accessorKey: "status",
  // },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
];

export const DivisionStockAdjustmentColumns = [
  {
    header: "Adjustment No",
    accessorKey: "adjustmentNo",
  },
   {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "Updated On",
    accessorKey: "updatedOn",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Updated By",
    accessorKey: "updatedBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
];

export const PickslipColumns = [
  {
    header: "Pickslip Number",
    accessorKey: "pickslipNumber",
  },
  {
    header: "Order Number",
    accessorKey: "orderNumber",
  },
  {
    header: "Wave Number",
    accessorKey: "waveNumber",
  },
  {
    header: "Cust Order Number",
    accessorKey: "custOrderNo",
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Date Pick Start",
    accessorKey: "datePickStart",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Date Pick Complete",
    accessorKey: "datePickComplete",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Picked By",
    accessorKey: "pickedBy",
  },
  {
    header: "Date Pack Start",
    accessorKey: "datePackStart",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Date Pack Complete",
    accessorKey: "datePackComplete",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Packed By",
    accessorKey: "packedBy",
  },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "Pallet Number",
    accessorKey: "palletNbr",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "Descriptions",
    accessorKey: "descriptions1",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "Quantity Allocated",
    accessorKey: "quantityAllocate",
  },
  {
    header: "Quantity Picked",
    accessorKey: "quantityPicked",
  },
  {
    header: "Computation",
    accessorKey: "computation",
  },
];

export const GRNReportEnquiryColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Recv Code",
    accessorKey: "recvCode",
  },
  {
    header: "Ext Recv Code",
    accessorKey: "extRecvCode",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "PO Number",
    accessorKey: "poNumber",
  },
  {
    header: "ASN Code",
    accessorKey: "asnCode",
  },
  {
    header: "PO Remark",
    accessorKey: "poRemark",
  },
  {
    header: "Receipt Date",
    accessorKey: "receiptDate",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Putaway Start",
    accessorKey: "putawayStart",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Putaway End",
    accessorKey: "putawayEnd",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Chargeable",
    accessorKey: "chargeable",
  },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Line No",
    accessorKey: "recvLineNo",
  },
  {
    header: "SKU Code",
    accessorKey: "recvSKUCode",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "SKU Descriptions",
    accessorKey: "descriptions1",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "V DO No",
    accessorKey: "vdoNo",
  },
  {
    header: "V Inv No",
    accessorKey: "vInvNo",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Manual Lot",
    accessorKey: "manualLot",
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "Manufacturing Date",
    accessorKey: "manufacturingDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Quantity Expected",
    accessorKey: "qtyExpected",
  },
  {
    header: "Quantity Received",
    accessorKey: "qtyReceived",
  },
  {
    header: "UOM",
    accessorKey: "uom",
  },
  {
    header: "Zone Id",
    accessorKey: "toZone",
  },
  {
    header: "Location Id",
    accessorKey: "toLocation",
  },
  {
    header: "Location Type",
    accessorKey: "locationType",
  },
  {
    header: "Cubic UPM",
    accessorKey: "upmCubic",
  },
  {
    header: "Total Cubic UPM",
    accessorKey: "totalUPMCubic",
  },
  {
    header: "Case UPM",
    accessorKey: "upmCase",
  },
  {
    header: "Total Case UPM",
    accessorKey: "totalUPMCases",
  },
  {
    header: "Putaway No",
    accessorKey: "putawayNumber",
  },
  {
    header: "Putaway Status",
    accessorKey: "putawayStatus",
  },
  {
    header: "Putaway By",
    accessorKey: "putawayBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateFn,
  },
  {
    header: "Updated On",
    accessorKey: "updatedOn",
    sortingFn: sortingDateFn,
  },
];

export const PickslipPickColumns = [
  {
    header: "Pickslip Number",
    accessorKey: "pickslipNumber",
  },
  {
    header: "Wave Number",
    accessorKey: "waveNumber",
  },
  {
    header: "Cust Order Number",
    accessorKey: "custOrdNbr",
  },
  {
    header: "Pick Method",
    accessorKey: "pickMethod",
  },
  {
    header: "Basket Id",
    accessorKey: "basketId",
  },
  {
    header: "Package Id",
    accessorKey: "packageId",
  },
  {
    header: "Location Id",
    accessorKey: "locationId",
  },
  {
    header: "Carton Id",
    accessorKey: "cartonId",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Quantity Allocated",
    accessorKey: "quantityAllocated",
  },
  {
    header: "Quantity Picked",
    accessorKey: "quantityPicked",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "Pickslip Status",
    accessorKey: "pickslipStatus",
  },
  {
    header: "Pick Status",
    accessorKey: "status",
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
];

export const PickslipPackColumns = [
  {
    header: "Pickslip Number",
    accessorKey: "pickslipNumber",
  },
  {
    header: "Wave Number",
    accessorKey: "waveNumber",
  },
  {
    header: "Cust Order Number",
    accessorKey: "custOrdNbr",
  },
  {
    header: "Pick Method",
    accessorKey: "pickMethod",
  },
  {
    header: "Basket Id",
    accessorKey: "basketId",
  },
  {
    header: "Box Id",
    accessorKey: "boxId",
  },
  {
    header: "Package Id",
    accessorKey: "packageId",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Box Type",
    accessorKey: "boxType",
  },
  {
    header: "Pickslip Status",
    accessorKey: "pickslipStatus",
  },
  {
    header: "Pack Status",
    accessorKey: "status",
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    filterFn: filterDateTimeFn,
    cell: (row) => convertDateTimeFormat(row.getValue()),
    sortingFn: sortingDateTimeYMDFn,
  },
];

export const laHistColumns = [
  {
    header: "Date",
    accessorKey: "date",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone Id",
    accessorKey: "zoneID",
  },
  {
    header: "Location Id",
    accessorKey: "locationID",
  },
  {
    header: "Location Type",
    accessorKey: "locationType",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "Consignee Code",
    accessorKey: "consigneeCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Cubic UPM",
    accessorKey: "upmCubic",
  },
  {
    header: "Total Cubic UPM",
    accessorKey: "totalUPMCubic",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Pallet Nbr",
    accessorKey: "palletNbr",
  },
  {
    header: "Carton Id",
    accessorKey: "cartonID",
  },
  {
    header: "Pallet Type",
    accessorKey: "palletType",
  },
  {
    header: "Hold Qty",
    accessorKey: "holdQty",
  },
  {
    header: "Hold Code",
    accessorKey: "holdCode",
  },
  {
    header: "Condition",
    accessorKey: "condition",
  },
  {
    header: "Full Pallet",
    accessorKey: "fullPlt",
  },
  {
    header: "Customs Lot",
    accessorKey: "customsLot",
  },
  {
    header: "Manual Lot",
    accessorKey: "manualLot",
  },
];

export const SKUBarcodeColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions 1",
    accessorKey: "descriptions1",
  },
  {
    header: "SKU Descriptions 2",
    accessorKey: "descriptions2",
  },
  // {
  //   header: "Color",
  //   accessorKey: "color",
  // },
  // {
  //   header: "Size",
  //   accessorKey: "size",
  // },
  // {
  //   header: "Style",
  //   accessorKey: "style",
  // },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "SKU Group",
    accessorKey: "skuGroup",
  },
  {
    header: "SKU Sub Group",
    accessorKey: "skuSubGroup",
  },
  // {
  //   header: "Movement Type",
  //   accessorKey: "movementType",
  // },
  // {
  //   header: "Selling Price",
  //   accessorKey: "sellingPrice",
  // },
  // {
  //   header: "Currency Code",
  //   accessorKey: "currencyCode",
  // },
  // {
  //   header: "Picking Rules",
  //   accessorKey: "pickingRules",
  // },
  // {
  //   header: "Shelf Life",
  //   accessorKey: "shelfLife",
  // },
  // {
  //   header: "Vendor Code",
  //   accessorKey: "vendorCode",
  // },
  // {
  //   header: "Vendor SKU",
  //   accessorKey: "vendorSKU",
  // },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "Pack Type Description",
    accessorKey: "packTypeDescription",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "Base UPM",
    accessorKey: "upmBase",
  },
  {
    header: "Innerpack UOM",
    accessorKey: "innerpackUOM",
  },
  {
    header: "Innerpack UPM",
    accessorKey: "upmInnerpack",
  },
  {
    header: "Case UOM",
    accessorKey: "caseUOM",
  },
  {
    header: "Case UPM",
    accessorKey: "upmCase",
  },
  {
    header: "Pallet UOM",
    accessorKey: "palletUOM",
  },
  {
    header: "Pallet UPM",
    accessorKey: "upmPallet",
  },
  {
    header: "Pallet Type",
    accessorKey: "palletType",
  },
  {
    header: "Gross Weight UOM",
    accessorKey: "grossWeightUOM",
  },
  {
    header: "Gross Weight UPM",
    accessorKey: "upmGrossWeight",
  },
  {
    header: "Net Weight UOM",
    accessorKey: "netWeightUOM",
  },
  {
    header: "Net Weight UPM",
    accessorKey: "upmNetWeight",
  },
  {
    header: "Cubic UOM",
    accessorKey: "cubicUOM",
  },
  {
    header: "Cubic UPM",
    accessorKey: "upmCubic",
  },
  {
    header: "Active",
    accessorKey: "active",
  },
];

export const PhysicalCountColumns = [
  {
    header: "PCount No",
    accessorKey: "pCountNo",
  },
  {
    header: "PCount Date",
    accessorKey: "pCountDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "PCount Freeze",
    accessorKey: "pCountFreeze",
  },
  {
    header: "Exclude Hold",
    accessorKey: "excludeHold",
  },
  {
    header: "Line No",
    accessorKey: "lineNo",
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Pallet Nbr",
    accessorKey: "palletNbr",
  },
  {
    header: "Sys Qty",
    accessorKey: "sysQty",
  },
  {
    header: "Phy Qty",
    accessorKey: "phyQty",
  },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Updated By",
    accessorKey: "updatedBy",
  },
  {
    header: "Updated On",
    accessorKey: "updatedOn",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
];

export const CycleCountColumns = [
  {
    header: "CCount No",
    accessorKey: "cCountNo",
  },
  {
    header: "CCount Date",
    accessorKey: "cCountDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "CCount Freeze",
    accessorKey: "cCountFreeze",
  },
  {
    header: "Exclude Hold",
    accessorKey: "excludeHold",
  },
  {
    header: "Line No",
    accessorKey: "lineNo",
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Pack Type",
    accessorKey: "packType",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Pallet Nbr",
    accessorKey: "palletNbr",
  },
  {
    header: "Sys Qty",
    accessorKey: "sysQty",
  },
  {
    header: "Phy Qty",
    accessorKey: "phyQty",
  },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Updated By",
    accessorKey: "updatedBy",
  },
  {
    header: "Updated On",
    accessorKey: "updatedOn",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
];

export const StockHoldColumns = [
  {
    header: "Stock Hold No",
    accessorKey: "stockHoldNo",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone",
    accessorKey: "zone",
  },
  {
    header: "Zone Type",
    accessorKey: "zoneType",
  },
  {
    header: "Location",
    accessorKey: "location",
  },
  {
    header: "Reason",
    accessorKey: "reason",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions1",
    accessorKey: "skuDescriptions1",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "PalletNbr",
    accessorKey: "palletNbr",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "Type",
    accessorKey: "type",
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Base UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "Remark",
    accessorKey: "remark",
  },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
];

export const StockAttributesColumns = [
  {
    header: "Stock Attributes No",
    accessorKey: "stockAttribNo",
  },
  {
    header: "Line No",
    accessorKey: "lineNo",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone",
    accessorKey: "zone",
  },
  {
    header: "Location",
    accessorKey: "location",
  },
  {
    header: "Reason",
    accessorKey: "reason",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions1",
    accessorKey: "skuDescriptions1",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "PalletNbr",
    accessorKey: "palletNbr",
  },
  {
    header: "Type",
    accessorKey: "type",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "New MLN",
    accessorKey: "newMLN",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "New Expiry Date",
    accessorKey: "newExpiryDate",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
];

export const recvSerialNumberColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Recv Code",
    accessorKey: "recvCode",
  },
  {
    header: "PO Number",
    accessorKey: "poNumber",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Serial Number",
    accessorKey: "serialNo",
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "Cust Order Number",
    accessorKey: "custOrdNbr",
  },
  {
    header: "Pickslip Number",
    accessorKey: "pickslipNumber",
  },
  {
    header: "Box ID",
    accessorKey: "boxID",
  },
  {
    header: "Container No",
    accessorKey: "containerNo",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
  {
    header: "Scanned On",
    accessorKey: "scannedOn",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "Scanned By",
    accessorKey: "scannedBy",
  },
];

export const loadManifestColumns = [
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Manifest Number",
    accessorKey: "manifestNumber",
  },
  {
    header: "Truck Number",
    accessorKey: "truckNo",
  },
  {
    header: "No of Drop Point",
    accessorKey: "noOfDroppoint",
  },
  {
    header: "Loading Date Time",
    accessorKey: "loadingDatetime",
    sortingFn: sortingDateTimeYMDFn,
  },
  {
    header: "PickUp Date",
    accessorKey: "pickUpDate",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "POD Date",
    accessorKey: "podDate",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "DO Number",
    accessorKey: "doNumber",
  },
  {
    header: "Customer Order Number",
    accessorKey: "custOrdNbr",
  },
  {
    header: "Tracking Number",
    accessorKey: "trackingNumber",
  },
  {
    header: "Carrier Code",
    accessorKey: "carrierCode",
  },
  {
    header: "T Small Carton",
    accessorKey: "tSmallCarton",
  },
  {
    header: "T Medium Carton",
    accessorKey: "tMediumCarton",
  },
  {
    header: "T Large Carton",
    accessorKey: "tLargeCarton",
  },
  {
    header: "T Pallet",
    accessorKey: "tPallet",
  },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateYMDFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
];

export const OrderTrackingColumns = [
  {
    header: "Tracking Number ID",
    accessorKey: "trackingNumberId",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  // {
  //   header: "Order ID",
  //   accessorKey: "orderId",
  // },
  {
    header: "Customer Order Number",
    accessorKey: "custOrdNbr",
  },
  // {
  //   header: "Package ID",
  //   accessorKey: "packageID",
  // },
  {
    header: "Tracking Number",
    accessorKey: "trackingNumber",
  },
  {
    header: "AWB Link",
    accessorKey: "awbLink",
  },
  {
    header: "Carrier",
    accessorKey: "carrier",
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
];

export const BillingChargeableColumns = [
  {
    header: "Bill Charge ID",
    accessorKey: "billChargeId",
  },
  {
    header: "Invoice Number",
    accessorKey: "invoiceNumber",
  },
  {
    header: "Supporting Code",
    accessorKey: "supportingCode",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "Billing Date From",
    accessorKey: "billDtFr",
  },
  {
    header: "Billing Date To",
    accessorKey: "billDtTo",
  },
  {
    header: "Invoice Date",
    accessorKey: "invoiceDate",
  },
  {
    header: "Billing Category",
    accessorKey: "billCategory",
  },
  {
    header: "Billing Line Number",
    accessorKey: "billLineNo",
  },
  {
    header: "Billing Item Code",
    accessorKey: "billItemCode",
  },
  {
    header: "Document Code",
    accessorKey: "documentCode",
  },
  {
    header: "Document Date",
    accessorKey: "documentDate",
  },
  {
    header: "Reference 1",
    accessorKey: "ref1",
  },
  {
    header: "Reference 2",
    accessorKey: "ref2",
  },
  {
    header: "Actual Quantity",
    accessorKey: "actualQty",
  },
  {
    header: "Charge Description",
    accessorKey: "chargeDesc",
  },
  {
    header: "Charge Type",
    accessorKey: "chargeType",
  },
  {
    header: "Charge Quantity",
    accessorKey: "chargeQty",
  },
  {
    header: "Charge Rate",
    accessorKey: "chargeRate",
  },
  {
    header: "Total Amount",
    accessorKey: "totalAmount",
  },
  {
    header: "Chargeable Amount",
    accessorKey: "chargeableAmount",
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
];

export const ReceivingScannedColumns = [
  {
    header: "ASN Number / CO Number",
    accessorKey: "asnNumber",
  },
  {
    header: "PO Number",
    accessorKey: "poNumber",
  },
  {
    header: "Vendor Code",
    accessorKey: "vendorCode",
  },
  // {
  //   header: "Main SKU",
  //   accessorKey: "mainSKU",
  // },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "DO Number",
    accessorKey: "vdoNo",
  },
  {
    header: "Carton ID",
    accessorKey: "cartonID",
  },
  {
    header: "Manufacturing Date",
    accessorKey: "manufacturingDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
    sortingFn: sortingDateFn,
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Serial Number",
    accessorKey: "serialNumber",
  },
  {
    header: "Recv Qty",
    accessorKey: "recvQty",
  },
  {
    header: "Recv UOM",
    accessorKey: "recvUOM",
  },
  // {
  //   header: "Computation",
  //   accessorKey: "computation",
  // },
  {
    header: "Condition Code",
    accessorKey: "conditionCode",
  },
  {
    header: "Recv Type",
    accessorKey: "recvType",
  },
  // {
  //   header: "Original MLN",
  //   accessorKey: "originalMLN",
  // },
  // {
  //   header: "Original Expiry Date",
  //   accessorKey: "originalExpiryDate",
  //   sortingFn: sortingDateTimeFn,
  // },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "Updated By",
    accessorKey: "updatedBy",
  },
  {
    header: "Updated On",
    accessorKey: "updatedOn",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
];

export const EmptyLocationColumns = [
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Location ID",
    accessorKey: "locationID",
  },
  {
    header: "Zone ID",
    accessorKey: "zoneID",
  } 
];

export const ReturnOrderScanColumns = [
  // { header: "Return Order Scan ID", accessorKey: "returnOrderScanId" },
  { header: "Recv Return No", accessorKey: "recvReturnNo" },
  { header: "Customer Code", accessorKey: "customerCode" },
  { header: "Vendor Code", accessorKey: "vendorCode" },
  { header: "Order Number", accessorKey: "orderNumber" },
  { header: "CustOrdNbr", accessorKey: "custOrdNbr" },
  { header: "Tracking Number", accessorKey: "trackingNumber" },
  { header: "Zone Type", accessorKey: "zoneType" },
  { header: "Warehouse Code", accessorKey: "warehouseCode" },
  { header: "To Zone", accessorKey: "toZone" },
  { header: "To Location", accessorKey: "toLocation" },
  { header: "SKU Code", accessorKey: "skuCode" },
  { header: "SKU Descriptions", accessorKey: "skuDescriptions" },
  { header: "Pack Type", accessorKey: "packType" },
  { header: "Barcode", accessorKey: "barcode" },
  { header: "MLN", accessorKey: "mln" },
  { header: "Expiry Date", accessorKey: "expiryDate" },
  { header: "Order Quantity", accessorKey: "orderQuantity" },
  { header: "Quantity Scan", accessorKey: "quantityScan" },
  { header: "Carton ID", accessorKey: "cartonID" },
  { header: "Basket ID", accessorKey: "basketID" },
  { header: "Status", accessorKey: "status" },
  { header: "Updated By", accessorKey: "updatedBy" },
  { header: "Updated On", accessorKey: "updatedOn" },
  { header: "Created By", accessorKey: "createdBy" },
  { header: "Created On", accessorKey: "createdOn" },
];

export const PutawayOrderScanColumns = [
  { header: "Pickslip Number", accessorKey: "pickslipNumber" },
  { header: "CustOrdNbr", accessorKey: "custOrdNbr" },
  { header: "Order Number", accessorKey: "orderNumber" },
  { header: "Warehouse Code", accessorKey: "warehouseCode" },
  { header: "To Zone", accessorKey: "toZone" },
  { header: "To Location", accessorKey: "toLocation" },
  { header: "SKU Code", accessorKey: "skuCode" },
  { header: "Pack Type", accessorKey: "packType" },
  { header: "OLN", accessorKey: "oln" },
  { header: "MLN", accessorKey: "mln" },
  { header: "Expiry Date", accessorKey: "expiryDate" },
  { header: "Order Quantity", accessorKey: "orderQuantity" },
  { header: "Quantity", accessorKey: "quantity" },
  { header: "Carton ID", accessorKey: "cartonID" },
  { header: "Manual Added", accessorKey: "manualAdded" },
  { header: "Status", accessorKey: "status" },
  { header: "Updated By", accessorKey: "updatedBy" },
  { header: "Updated On", accessorKey: "updatedOn" },
  { header: "Created By", accessorKey: "createdBy" },
  { header: "Created On", accessorKey: "createdOn" },
];

export const InterDivisioninventoriesColumns = [
  { header: "Warehouse Code", accessorKey: "warehouseCode" },
  { header: "SKU Code", accessorKey: "skuCode" },
]

export const DivisioninventoriesColumns = [
  { header: "SKU Code", accessorKey: "skuCode" },
]

export const DivisionBalanceCheckColumns = [
  { header: "SKU Code", accessorKey: "skuCode" },
  { header: "Storage Qty", accessorKey: "groupQty" },
  { header: "Division Qty", accessorKey: "divisionQty" },
  { header: "Balance", accessorKey: "balance" },
  { header: "Cause", accessorKey: "cause" },
  { header: "Documents", accessorKey: "documents" },
  { header: "Inbound", accessorKey: "inboundGap" },
  { header: "Adj / Transfer", accessorKey: "otherGap" },
  { header: "Alloc / Pick", accessorKey: "allocPickGap" },
]

export const divisionMovementEnquiryColumns = [
  {
    header: "Date",
    accessorKey: "date",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Activity",
    accessorKey: "activity",
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "SKU Descriptions",
    accessorKey: "skuDescriptions",
  },
  // {
  //   header: "Opening Quantity",
  //   accessorKey: "openingQuantityStr",
  // },
  {
    header: "In Quantity",
    accessorKey: "inQuantityStr",
  },
  {
    header: "Out Quantity",
    accessorKey: "outQuantityStr",
  },
  {
    header: "Adjust Quantity",
    accessorKey: "adjustQuantityStr",
  },
  // {
  //   header: "Closing Quantity",
  //   accessorKey: "closingQuantityStr",
  // },
  {
    header: "Ref 1",
    accessorKey: "ref1",
  },
  {
    header: "Ref 2",
    accessorKey: "ref2",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
];

export const divisionGRNEnquiryColumns = [
  {
    header: "Division",
    accessorKey: "division",
  },
  {
    header: "Division Customer",
    accessorKey: "divisionCustomer",
  },
  {
    header: "Recv Code",
    accessorKey: "recvCode",
  },
  {
    header: "PO Number",
    accessorKey: "poNumber",
  },
  {
    header: "ASN Code",
    accessorKey: "asnCode",
  },
  {
    header: "Receipt Date",
    accessorKey: "receiptDate",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Putaway Start",
    accessorKey: "putawayStart",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Putaway End",
    accessorKey: "putawayEnd",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Chargeable",
    accessorKey: "chargeable",
  },
  {
    header: "Status",
    accessorKey: "status",
  },
  {
    header: "SKU Code",
    accessorKey: "recvSKUCode",
  },
  {
    header: "Category",
    accessorKey: "category",
  },
  {
    header: "SKU Descriptions",
    accessorKey: "descriptions1",
  },
  {
    header: "V DO No",
    accessorKey: "vDONo",
  },
  {
    header: "V Inv No",
    accessorKey: "vInvNo",
  },
  {
    header: "Quantity Division",
    accessorKey: "qtyDivision",
  },
  {
    header: "UOM",
    accessorKey: "uom",
  },
  {
    header: "Putaway No",
    accessorKey: "putawayNumber",
  },
  {
    header: "Putaway Status",
    accessorKey: "putawayStatus",
  },
  {
    header: "Putaway By",
    accessorKey: "putawayBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateFn,
  },
  {
    header: "Updated On",
    accessorKey: "updatedOn",
    sortingFn: sortingDateFn,
  },
];

export const DivisionStockTransferColumns = [
  {
    header: "Transfer No",
    accessorKey: "transferNo",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    sortingFn: sortingDateTimeFn,
  },
  {
    header: "Customer Code",
    accessorKey: "customerCode",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Transfer Qty",
    accessorKey: "quantity",
  },
  {
    header: "UOM",
    accessorKey: "baseUOM",
  },
  {
    header: "Created By",
    accessorKey: "createdBy",
  },
];